import { Box } from "@mui/material";
import { api } from "../services/api";
import { useApiData } from "../hooks/useApiData";
import { useSession } from "../context/SessionContext";
import { DataState } from "../components/Feedback";
import PageHeader from "../components/PageHeader";
import SectionCard from "../components/SectionCard";
import DataTable, { TwoLine } from "../components/DataTable";
import StatusChip from "../components/StatusChip";
import { AUDIT, FINDING_STATUS, RISK_LEVEL } from "../constants";
import { formatDate } from "../utils/format";

export default function AuditsPage() {
  const { clientId } = useSession();
  const audits = useApiData(() => api.getAudits(), [clientId]);
  const findings = useApiData(() => api.getFindings(), [clientId]);

  const auditColumns = [
    { key: "name", label: "Audit", render: (a) => <TwoLine main={a.name} sub={a.frameworkCode} /> },
    { key: "auditor", label: "Auditor" },
    { key: "status", label: "Status", render: (a) => <StatusChip label={a.statusLabel} color={AUDIT[a.status].color} /> },
    { key: "startDate", label: "Period", render: (a) => `${formatDate(a.startDate)} – ${formatDate(a.endDate)}` },
    { key: "openFindings", label: "Open findings", align: "right" },
  ];

  const findingColumns = [
    {
      key: "severity", label: "Severity", width: 130,
      render: (f) => <StatusChip label={f.severityLabel} color={RISK_LEVEL[f.severity].color} />,
    },
    { key: "title", label: "Finding", render: (f) => <TwoLine main={f.title} sub={f.auditName} /> },
    { key: "owner", label: "Owner" },
    { key: "status", label: "Status", render: (f) => <StatusChip label={f.statusLabel} color={FINDING_STATUS[f.status].color} /> },
    {
      key: "dueDate", label: "Due",
      render: (f) => (f.overdue ? <StatusChip label={`Overdue · ${formatDate(f.dueDate)}`} color="#EF4444" /> : formatDate(f.dueDate)),
    },
  ];

  return (
    <>
      <PageHeader title="Audits & Findings" subtitle="Assessments against each framework, and the issues they raised." />
      <Box sx={{ display: "grid", gap: 3 }}>
        <SectionCard title="Audits">
          <DataState state={audits}>{(rows) => <DataTable columns={auditColumns} rows={rows} emptyText="No audits yet." />}</DataState>
        </SectionCard>
        <SectionCard title="Findings" subtitle="Most severe first">
          <DataState state={findings}>{(rows) => <DataTable columns={findingColumns} rows={rows} emptyText="No findings." />}</DataState>
        </SectionCard>
      </Box>
    </>
  );
}
